import createRoute    from '@widesk-ui/tools/createRoute';
import EventTypeModel from '@models/website/EventTypeModel';

const route = createRoute.splitView(
	'/configuration/event_types',
	'website',
	'EventTypeSplitView',
	EventTypeModel.localize('plural'),
);
export default route;
